import styled from 'styled-components';

export const ScRegFormPayments = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;

  & > img {
    width: auto;
  }
`;
